import React, { useState } from 'react'
import Layout from '../../../components/layouts'
import Banner from '../../../components/features/Banner'
import Question from '../../../components/features/Question'
import Video from '../../../components/features/Video'
import Info from '../../../components/features/Info'
import Steps from '../../../components/features/Steps'
import SEO from '../../../components/common/SEO';
import FeatureCards from "../../../components/features/FeatureCards"

export const query = graphql`
  query BulletinsQuery {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl: url
        defaultImage: image
        twitterUsername
      }
    }
  }
`

export default ({ data }) => {
    const [toggler, setToggler] = useState(false)
    const lightboxProps = {
        toggler: toggler,
        setToggler: setToggler,
        sources: ["https://www.youtube.com/watch?v=xE2yXvWB038"],
    }

    const bannerProps = {
        title: 'Bulletins and Alerts',
        subtitle: 'Communication on a timely basis is key to any compliant organization. With Workhub, management can communicate with their workers effectively via email, SMS, or both and can keep track of all views a bulletin receives. Bulletins can be sent with an elevated priority status of Alert to let your team know the information contained is critical and should be viewed right away.',
        featureName: 'Bulletin',
        rightButtonText: 'Why Bulletin Software?',
        rightButtonSrc: 'https://www.youtube.com/watch?v=xE2yXvWB038',
        mockupImg: '/features/bulletins/device-mockup.png'
    }

    const questionProps = {
        question: 'Has your bulletin board become a piece of antique abstract art?',
        answer: 'Bulletin boards aren’t the ideal method of communication, with notes piled on top of notes and important messages being buried by classified ads and lost and found sticky notes. Worse yet, how can we assess who got the memo? There are many issues, such as:',
        answerBulletList: [
            'no way to ensure prompt readership',
            'nearly impossible to audit who received and who read',
            'hard to get feedback on messages',
            'tough to classify or target specific teams / locations',
        ],
        imageSrc: '/features/sketch/bulletin-large.png',
        imgAlt: 'Cartoon of an old Bulletin board that is too full of Bulletins and Alerts'
    }

    const videoProps = {
        videoSrc: 'https://www.youtube.com/watch?v=xE2yXvWB038',
        videoImage: '/features/bulletins/bulletins-thumbnail.jpg',
        videoStatement: (<h2><strong>Bulletins and Alerts</strong></h2>),
    }

    const infoProps = {
        infoList: [
            {
                mockupImage: '/features/bulletins/feature-large-admin-bulletins-1.jpg',
                infoTitle: 'Create content-rich bulletins with attachments',
                infoSubtitle: 'Choose from nine different types of bulletins to keep your messages organized by function. Three different priority choices allow you to indicate to workers if a bulletin is urgent, required, or optional. Compose your bulletins using rich text and styling, or attach a file for your workers to review. Workers can add comments to each bulletin, so you can address and questions or concerns they might have.',
                infoBullets: [
                    {
                        name: 'Notify by SMS:',
                        description: 'SMS (text message) notifications assure direct and instant delivery. Workers can click the link in the text and read the bulletin right away.'
                    },
                    {
                        name: 'Email by Email:',
                        description: 'let your selected team members know a bulletin is available to read through email notifications sent as soon as you post',
                    },
                    {
                        name: 'Save drafts for easy templating:',
                        description: 'not quite ready to post? Want to create a template to use in future bulletins? Save a bulletin as a draft and use it later.',
                    }
                ],
            },
            {
                mockupImage: '/features/bulletins/feature-large-admin-bulletins-2.jpg',
                infoTitle: 'Track views with adjustable audiences and review times',
                infoSubtitle: 'Easily configure who will receive your bulletin and set how long you would them to view it before it’s considered done. Set an Archive Date to configure when bulletins will no longer need to be reviewed by new hires or folks who haven’t yet seen them. Add or remove recipients after a bulletin has been posted, in case your audience changes.',
                infoBullets: [
                    {
                        name: 'Recipient Filtering:',
                        description: 'choose your recipients by filtering by location and/or Position to bulletins only go to exactly who needs them.'
                    },
                    {
                        name: 'Send Reminders:',
                        description: 'readership down? Send a reminder to all workers that haven’t reviewed the bulletin go prompt their readership.',
                    },
                    {
                        name: 'Commenting:',
                        description: 'Workers can comment on bulletins, and admins can approve the comments left to make them visible to everyone.',
                    }
                ],
            }
        ]
    }

    const stepsProps = {
        title: 'Notifying Workers is as Easy as 1, 2, 3',
        subtitle: 'Updating your workers on all devices/platforms and tracking readership has never been easier',
        stepList: [
            {
                title: 'Get the notification via SMS / Email',
                subtitle: 'Workers are notified instantly to take prompt action by clicking the link that appears by SMS or email',
                imageSrc: '/features/bulletins/bulletins-step-1-alert.jpg'
            },
            {
                title: 'Read the Bulletin',
                subtitle: 'Read and review the bulletin and attachments to update your status to Done',
                imageSrc: '/features/bulletins/bulletins-step-2-read.jpg'
            },
            {
                title: 'Stay up-to-date',
                subtitle: 'Knock off your items to do and stay current with your team',
                imageSrc: '/features/bulletins/bulletins-step-3-compliance.jpg'
            }
        ]
    }

    const seo = {
        title: 'Workhub | Free Bulletin and Alerts Software',
        description: "Ensure that important communications are received by workers & gain safety compliance by implimenting our Bulletin & Alert Software. Filter recipients, notify by SMS, 'read' reciept enabled.",
        image: '/features/bulletins/bulletins-thumbnail.jpg',
        // pathname,
        // article
    }


    const featureIndex = [
        {
            title: "Notify",
            para: "Ensure workers are reading important correspondence by sending out bulletins and alerts though email and SMS. ",
        },
        {
            title: "Recipient Filtering",
            para: "Select the recipients by position and location to ensure the bulletins and alerts go to relevant workers. ",
        },
        {
            title: "Set a Review Clock",
            para: "Choose a length of time the bulletins and alerts must be reviewed for before they can be considered acknowledged.",
        },
        {
            title: "Read Receipts",
            para: "Read receipts allow admins to see who has reviewed the bulletins and who has not.",
        },
        {
            title: "Send Reminders",
            para: "Send a reminder to all workers that have not reviewed the bulletin to prompt more readership.",
        },
        {
            title: "Commenting",
            para: "Workers can comment on bulletins and admins can approve the comment to make it public to all workers.",
        },
    ]


    return (
        <Layout {...lightboxProps}>
            <SEO {...seo} {...data.site} />
            <Banner {...bannerProps} {...lightboxProps} />
            <Question {...questionProps} />
            <Video {...videoProps} {...lightboxProps} />
            <Info {...infoProps} />
            <Steps {...stepsProps} />

            <section className="feature-overview-container" style={{marginBottom: '60px'}}>
                <h2>Overview</h2>

                <div className="feature-overview-grid">
                    {featureIndex.map(item => (
                        <FeatureCards title={item.title} para={item.para} />
                    ))}
                </div>
            </section>

        </Layout>
    )
}